export default __webpack_public_path__ + "static/media/about-img3.79fa9cbd.png";